// Meta-tag names the layout renders geo into and instrumentation-client reads
// back. Posthog-free module so the server layout can import them safely.
export const GEO_COUNTRY_META_NAME = 'x-geo-country'
export const GEO_REGION_META_NAME = 'x-geo-region'
